export default {
   components: {
      
   },
   routes: [
      {
         path: '/',
         component: () => import(`./login`),
         name: 'LogIn'
      }
   ]
}